export default (function ($, Drupal, once) {
  class CustomFile {
    constructor($input) {
      this.$input = $input;

      this.$wrapper = this.$input.parent();

      this.$selectButton = this.$wrapper.find('.js-choose-file');

      this.events();
    }

    events() {
      this.$selectButton.on('click', () => {
        this.$input.trigger('click');
      });
    }
  }

  Drupal.behaviors.veoliaFile = {
    attach: (context) => {
      $(once('customFile', 'input[type="file"]', context)).each(function () {
        new CustomFile($(this));
      });

      $('.support-send-message .remove-button').addClass('disable-remove-button');

      $('.support-send-message .form-check input').click(function () {
        if ($(this).is(':checked')) {
          $('.support-send-message .remove-button').removeClass('disable-remove-button');
        } else {
          $('.support-send-message .remove-button').addClass('disable-remove-button');
        }
      });

      $('a.support-file-attachment').each(function () {
        const urllink = $(this).text();
        const filename = urllink.substring(urllink.lastIndexOf('/') + 1).split('?')[0];
        $(this).text(filename);
      });
    },
  };
}(jQuery, Drupal, once));
